<template>
  <vs-prompt
    title="提示"
    @close="closeHandle"
    class="active-prompt"
    buttons-hidden
    :active.sync="dialogShow">
    <div class="con-exemple-prompt">
      <div class="content">
        <p>
          <icon-svg
            class="theme-color"
            icon-class="tixing"
            style="margin-right: 5px;"
          ></icon-svg>
          <span
            v-html="text"
          ></span>
        </p>
      </div>
      <div class="btn-modules">
        <el-button
          type="primary"
          @click="submitHandle"
          :loading="loading"
        >提交</el-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
export default {
  name: "mulyipleDeleteDialog",
  props: {
    ids: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      dialogShow: false,
      loading: false,
    }
  },
  computed: {
    text(){
      return `确定对<span class="theme-color">[id=${this.ids.join(',')}]</span>进行[${(this.ids.length == 1) ? '删除' : '批量删除'}]操作?`
    },
  },
  methods: {
    closeHandle(){
      this.dialogShow = false;
    },
    submitHandle(){
      this.$emit('sure-delete',this.ids);
    }
  },
}
</script>

<style lang="scss">
@import "../../assets/scss/variable";
.active-prompt.con-vs-dialog {
  z-index: 1001;
  .vs-dialog .vs-dialog-header .dialog-title {
    color: $themefontcolor;
  }
  .vs-dialog {
    width: 614px;
    max-width: none;

    .vs-dialog-header .dialog-title {
      color: $themefontcolor;
    }

    .vs-dialog-text {
      padding: 0 !important;
    }
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    border-bottom: 1px solid #E0E4F2;
  }
  .btn-modules {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
